<div
  class="flex"
  [ngClass]="message.summary ? 'items-start' : 'items-center'"
>
  <div
    class="mr-3 mt-1"
    *ngIf="message.severity"
  >
    <app-svg-viewer [svg]="loadIcon(message.severity)!"></app-svg-viewer>
  </div>
  <div class="flex-1">
    <h1
      *ngIf="message.summary"
      class="text-lg font-semibold mb-1"
    >
      {{ message.summary }}
    </h1>
    <p
      class="text-sm m-0"
      *ngIf="message.detail"
    >
      {{ message.detail }}
    </p>
  </div>
</div>
